import React from 'react'
import Resources1 from "../../assets/imgs/blog-1.webp"
import Resources2 from "../../assets/imgs/blog-2.webp"
import Resources3 from "../../assets/imgs/blog-3.webp"

const Resources = () => {
    return (
        <section id="resourcesDiv" className="resourcesSec">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-lg-12 text-center mb-3">
                        <h2 className="h1">
                            Resources
                        </h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 col-lg-4">
                        <div className="card">
                            <div className="resourcesCard_img">
                                <img alt="Non-Profit CRM" src={Resources1} width="419" height="231" />
                            </div>
                            <div className="card-body">
                                <p className="card-subtitle mb-2 text-muted">December 14,2022</p>
                                <h5 className="card-title"><a href="https://dynamicscrmconsulting.com/nonprofit-crm" target="_blank" aria-label="Non-Profit CRM">Nonprofit CRM: Elevating the Game of Nonprofits</a></h5>
                                <p className="card-text">Nonprofit organizations, over the years, have realized the importance of automation in revolutionizing fundraising. To empower their campaigns...</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-lg-4">
                        <div className="card">
                            <div className="resourcesCard_img">
                                <img alt="Non-Profit CRM" src={Resources2} width="419" height="231" />
                            </div>
                            <div className="card-body">
                                <p className="card-subtitle mb-2 text-muted">Febuary 22,2023</p>
                                <h5 className="card-title"><a href="https://dynamicscrmconsulting.com/grant-management-checklist" aria-label="How to Manage Grants" target="_blank">How to Manage Grants: The Ultimate Checklist</a></h5>
                                <p className="card-text">For nonprofits, grants can be a crucial source of funding that
                                    enables them to implement crucial initiatives. But managing grants can be a
                                    tedious..</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-lg-4">
                        <div className="card">
                            <div className="resourcesCard_img">
                            <img alt="Non-Profit CRM" src={Resources3} width="419" height="231" />
                            </div>
                            <div className="card-body">
                                <p className="card-subtitle mb-2 text-muted">November 29, 2022</p>
                                <h5 className="card-title"><a href="https://dynamicscrmconsulting.com/dynamics-365-fundraising-and-engagement" aria-label="Dynamics 365 Fundraising" target="_blank">Dynamics 365 Fundraising and Engagement- Fostering Relationships</a></h5>
                                <p className="card-text">Many nonprofit organizations look for ways to improve their
                                    operational efficiencies and efficiently manage their profiles to maintain..</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </section>
    )
}

export default Resources